import React, { useEffect, useState } from "react";
import { PageHeader, StatCard } from "../../components/Shell";
import { api } from "../../lib/api";

export default function SuperDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats/super").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="super-dashboard">
      <PageHeader eyebrow="Super Admin" title="Platform overview" />

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <StatCard label="Organizations" value={stats?.organizations ?? "—"} accent />
        <StatCard label="Active Orgs" value={stats?.active_orgs ?? "—"} />
        <StatCard label="Org Admins" value={stats?.org_admins ?? "—"} />
        <StatCard label="Members" value={stats?.members ?? "—"} />
        <StatCard label="Events" value={stats?.events ?? "—"} />
      </div>

      <div className="mt-10 grid md:grid-cols-2 gap-4">
        <div className="border border-[#E4E4E7] bg-white p-6">
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#05126E]">
            Quick links
          </div>
          <div className="mt-4 space-y-2">
            <a className="block px-3 py-2 border border-[#E4E4E7] hover:border-[#0a0a0a]" href="/super/organizations">
              → Manage organizations
            </a>
            <a className="block px-3 py-2 border border-[#E4E4E7] hover:border-[#0a0a0a]" href="/super/org-admins">
              → Manage Org Admins
            </a>
          </div>
        </div>
        <div className="border border-[#E4E4E7] bg-white p-6">
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#05126E]">
            How it works
          </div>
          <ol className="mt-4 space-y-2 text-sm text-zinc-700 list-decimal list-inside">
            <li>Create an organization.</li>
            <li>Provision an Org Admin for that organization.</li>
            <li>Org Admin signs in to manage members, events, and run the scanner.</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
